var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5004 23.8204L7.14073 27.8592C6.39181 28.221 5.8815 27.8616 6.00118 27.0546L7.21154 18.8932C7.28337 18.4088 7.05898 17.7322 6.70991 17.3815L0.835461 11.4794C0.252595 10.8938 0.448037 10.3068 1.27604 10.1677L9.56137 8.77543C10.0565 8.69222 10.6464 8.27383 10.8792 7.84039L14.7992 0.54104C15.1865 -0.179989 15.8139 -0.180704 16.2015 0.54104L20.1215 7.84039C20.3542 8.27359 20.9418 8.69183 21.4394 8.77543L29.7247 10.1677C30.5509 10.3065 30.7476 10.8943 30.1653 11.4794L24.2908 17.3815C23.9419 17.732 23.7173 18.4086 23.7892 18.8932L24.9995 27.0546C25.1191 27.8608 24.6083 28.2207 23.86 27.8592L15.5004 23.8204Z",
    fill: "#FFB21D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.18028f7a2491b3d8c728fa6ac29f5bc9.svg";
export { ForwardRef as ReactComponent };